import { FC, useEffect } from 'react';

import { TripTypeEnum } from '@mopla/data-models';
import { useLogger } from '@mopla/logger';

import disabledIcon from './car/Disabled.svg?url';
import { ExtendedVehicleType, IVehicleIconProps } from './types';
import { resolveVehicleIconUrl } from './utils';

const sizeMap: Record<'xs' | 's' | 'm' | 'l', number> = {
	xs: 16,
	s: 30,
	m: 48,
	l: 80,
};

function resolveAltText(
	mode: TripTypeEnum | 'MIXED',
	vehicleType?: ExtendedVehicleType
): string {
	if (mode === TripTypeEnum.PRODT && vehicleType) {
		return `MyWay ${vehicleType}`;
	}

	if (mode === TripTypeEnum.LBODTFLEX) {
		return vehicleType === 'LBODTFLEX_WITH_PASSENGERS'
			? 'On-Demand (with passengers)'
			: 'On-Demand';
	}

	return mode;
}

function getOpacity(isActive: boolean) {
	return isActive ? 1 : 0.6;
}

export const VehicleIcon: FC<IVehicleIconProps> = ({
	mode,
	vehicleType,
	size = 'm',
	isActive = true,
	...restProps
}) => {
	const logger = useLogger('VehicleIcon');

	const iconUrl = resolveVehicleIconUrl(mode, vehicleType);

	useEffect(() => {
		if (!iconUrl) {
			logger.warn('Icon not found', {
				mode,
				vehicleType,
			});
		}
	}, [iconUrl, logger, mode, vehicleType]);

	const resolvedSize = typeof size === 'number' ? size : sizeMap[size];

	return (
		<img
			src={iconUrl || disabledIcon}
			alt={resolveAltText(mode, vehicleType)}
			width={resolvedSize}
			height={resolvedSize}
			style={{
				opacity: getOpacity(isActive),
			}}
			{...restProps}
		/>
	);
};
